import React, { useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  TextField,
  CircularProgress,
  Tooltip,
  Popover,
  Typography,
} from "@mui/material";
import { Field, Form, Formik, getIn, ErrorMessage, FieldArray } from "formik";
import * as yup from "yup";
import { theme } from "../App";
import { connect } from "react-redux";
import LockIcon from "@mui/icons-material/Lock";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AutoCompleteMultiSelect from "../../components/autoCompleteComponent/AutoCompleteMultiSelect";
import MuiButton from "../../components/muiButton/MuiButton";
import MuiTextField from "../../components/muiTextField/MuiTextField";
import InfluencersActivityAction from "../../stores/influencersActivity/InfluencersActivityAction";
import DatePicker from "../../components/dateRangePickerComponent/DateRangePicker";
import { format } from "date-fns";
import environment from "environment";
import DateRangePickerFormik from "../../components/dateRangePickerComponent/DateRangePickerFormik";
import SwitchButton from "../../components/switchComponent/SwitchButton";
import DatePickerComponent from "../../components/datePickerComponent/DatePickerComponent";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./influencerActivityPost.css";
import InfluencersCampaignsAction from "../../stores/influencersCampaigns/InfluencersCampaignsAction";
import UserAction from "../../stores/user/UserAction";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import RemoveCircleOutlineTwoToneIcon from "@mui/icons-material/RemoveCircleOutlineTwoTone";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import HighlightOffTwoToneIcon from "@mui/icons-material/HighlightOffTwoTone";

// mapstateto props function
const mapStateToProps = (state) => ({
  isRequesting: selectRequesting(state, [UserAction.REQUEST_USER]),
  user: state.user.user || [],
});

function AddAllActivity(props) {
  // user id
  // const [id, setId] = useState(
  //   Math.floor(Math.random() * (999 - 100 + 1) + 100)
  // );'

  const { token, campaign } = props;
  // const [fileInputs, setFileInputs] = useState([
  //   { id: new Date().toISOString() },
  // ]);
  const [showPassword, setShowPassword] = React.useState(false);
  const buttonForLoginRef = React.useRef(null);
  const [date, setDate] = useState([null, null]);
  const [campaignId, setCampaignId] = useState();

  let activity_type_list = props.activityTypeList;

  let filtered_activity_type_list = [];

  if (activity_type_list.length > 0) {
    filtered_activity_type_list = activity_type_list.filter((item) => {
      return item.campaign_id === campaignId;
    });
  }

  if (filtered_activity_type_list.length > 0) {
    filtered_activity_type_list = filtered_activity_type_list.map((item) => {
      return {
        activity_type_id: item.activity_type_id,
        activity_type_name: item.activity_type_name,
      };
    });
  }

  let date_format = [];

  if (date[0]) {
    date_format.push(date[0].$d);
  }

  if (date_format[0]) {
    format(date_format[0], "yyyy-mm-dd");
  }

  if (date[1]) {
    date_format.push(date[1].$d);
  }

  if (date_format[1]) {
    format(date_format[1], "yyyy-mm-dd");
  }

  const dateHandlechange = (value) => {
    if (value === null) {
      setDate([null, null]);
    } else {
      setDate(value);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // status object return to show in edit mode
  let statusList = props.statusList;
  const returnStatusObject = (statusId) => {
    let filtered_status =
      statusList.length > 0 &&
      statusList.filter((val) => {
        return val.status_id === statusId;
      });

    return filtered_status.length > 0 ? filtered_status[0] : ``;
  };

  // activity type object return to show in edit mode
  let activityTypeList = props.activityTypeList;
  const returnActivityTypeObject = (activityTypeId) => {
    let filtered_activityType =
      activityTypeList.length > 0 &&
      activityTypeList.filter((val) => {
        return val.activity_type_id === activityTypeId;
      });

    return filtered_activityType.length > 0 ? filtered_activityType[0] : ``;
  };

  const returnTagObject = (item) => {
    let filtered_tag =
      props.tagList.length > 0 &&
      props.tagList.filter((val) => {
        return val.tag_id === item;
      });

    return filtered_tag.length > 0 ? filtered_tag[0] : ``;
  };

  const returnTagsArray = (arrayOfIds) => {
    let array_of_objects = [];

    arrayOfIds.map((item) => {
      array_of_objects.push(returnTagObject(item));
    });

    return array_of_objects;
  };

  function setCustomFieldValueType(data) {
    if (data === "text") {
      return [{ value: "", id: "" }];
    } else if (data === "select") {
      return [{ value: "", id: "" }];
    } else if (data === "date") {
      return [{ value: "", id: "" }];
    } else if (data === "multiselect") {
      return [];
    } else if (data === "radio") {
      return [{ value: "", id: "" }];
    } else if (data === "toggle") {
      return [{ value: "", id: "" }];
    } else {
      return [];
    }
  }

  let custom_value = [];
  if (props.customticketfields) {
    props.customticketfields.hits &&
      props.customticketfields.hits.hits &&
      props.customticketfields.hits.hits.map((item) => {
        return custom_value.push({
          field_id: item._id,
          field_name: item._source.field_name,
          field_type: item._source.field_type,
          field_values: setCustomFieldValueType(item._source.field_type),
        });
      });
  }
  let customFieldInitialValues = [];
  if (custom_value.length != 0) {
    customFieldInitialValues = custom_value;
  }

  //Initial values
  let initial = {};
  if (props.edit) {
    initial = {
      activity_name: props.activityEditData._source.activity_name,
      description: props.activityEditData._source.description,
      // thumbnail_url: props.activityEditData._source.thumbnail_url,
      activity_url: props.activityEditData._source.activity_url,
      activity_duration: [
        props.activityEditData._source.activity_duration &&
          props.activityEditData._source.activity_duration.from_date,
        props.activityEditData._source.activity_duration &&
          props.activityEditData._source.activity_duration.to_date,
      ],
      activity_type: returnActivityTypeObject(
        props.activityEditData._source.activity_type
      ),
      activity_platform: props.activityEditData._source.activity_platform,
      // activity_location: props.activityEditData._source.activity_location,
      activity_post_details:
        props.activityEditData._source.activity_post_details,
      campaign:
        campaign === false
          ? props.campaign_obj
          : props.activityEditData._source.campaign,
      influencer: props.activityEditData._source.influencer,
      activity_status: returnStatusObject(
        props.activityEditData._source.activity_status
      ),
      // activity_tag: props.activityEditData._source.activity_tag
      //   ? returnTagsArray(props.activityEditData._source.activity_tag)
      //   : [],

      activity_content: props.activityEditData._source.activity_content,
      custom_value: props.activityEditData._source.custom_fields && [
        ...props.activityEditData._source.custom_fields,
      ],
      boolean: false,
    };
  } else {
    initial = {
      activity_name: "",
      description: "",
      // thumbnail_url: "",
      activity_url: "",
      activity_duration: [null, null],
      activity_type: "",
      activity_platform: "",
      // activity_location: "",
      campaign: campaign === false ? props.campaign_obj : "",
      influencer: "",
      activity_status: "",
      activity_content: "",
      // activity_tag:
      // props.tagList.length > 0 && props.tagList.length === 1
      //   ? props.tagList[0]
      //   : [],
      boolean: false,
      custom_value: customFieldInitialValues,
    };
  }

  const [loading, setLoading] = React.useState(false);

  const RequiredText = () => {
    return <span style={{ fontSize: "15px" }}>Required *</span>;
  };

  let [activity_platform_list, setactivity_platform_list] = useState([]);

  const fetchCampaignFunction = (campaign) => {
    let campaigncallback = (resp) => {
      setactivity_platform_list([...resp?._source?.target_platforms]);
    };

    props.dispatch(
      InfluencersCampaignsAction.requestInfluencerCampaignsById(
        campaign?.campaign_id,
        campaigncallback
      )
    );
  };

  useEffect(() => {
    if (props.edit) {
      if (props.activityEditData._source.campaign) {
        fetchCampaignFunction(props.activityEditData._source.campaign);
      }
    }
  }, [props.edit]);

  useEffect(() => {
    if (!campaign) {
      fetchCampaignFunction(props.campaign_obj);
    }
  }, [campaign]);

  //File upload
  // const handleFileUpload = (value, setFieldValue, event) => {
  //   setFieldValue("boolean", true);

  //   // event.preventDefault();
  //   let formData = new FormData();
  //   formData.append("file", value);

  //   let access_tocken = localStorage.getItem("Auth")
  //     ? JSON.parse(localStorage.getItem("Auth")).access_token
  //     : "";

  //   fetch(`${environment.api.baseApi}/file_upload/add`, {
  //     method: "POST",
  //     headers: {
  //       Authorization: "Bearer " + access_tocken,
  //       // Accept: "application/json",
  //       // "Content-Type": "application/json",
  //     },
  //     body: formData,
  //   })
  //     .then((res) => res.json())
  //     .then((response) => {
  //       setFieldValue("boolean", false);
  //     })
  //     .catch((error) => {
  //       setFieldValue("boolean", false);
  //     });
  // };

  // const handleAddFile = () => {
  //   setFileInputs((prevInputs) => [
  //     ...prevInputs,
  //     { id: new Date().toISOString() },
  //   ]);
  // };

  // const handleRemoveFile = (idToRemove) => {
  //   setFileInputs((prevInputs) =>
  //     prevInputs.filter(({ id }) => id !== idToRemove)
  //   );
  // };

  const [popperOpen, setPopperOpen] = useState(false);

  const handlePopoverOpen = (event) => {
    setPopperOpen(true);
    setTimeout(() => {
      setPopperOpen(false);
    }, 700);
  };
  const handlePopoverClose = () => {
    setPopperOpen(false);
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => {
        handlePopoverOpen();
      }}
      fullWidth
      maxWidth="md"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "8px",
          boxShadow: "8px 8px 12px rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <Formik
        initialValues={initial}
        validate={(values) => {
          var errors = {};
          if (!values.activity_name) {
            errors.activity_name = "Activity Name is Required";
          }
          if (!values.description) {
            errors.description = "Description is Required";
          }
          // if (!values.thumbnail_url) {
          //   errors.thumbnail_url = "Thumbnail url is Required";
          // }
          if (!values.activity_url) {
            errors.activity_url = "Activity url is Required";
          }

          if (!values.activity_duration[0] && !values.activity_duration[1]) {
            errors.activity_duration = <RequiredText />;
          }

          if (!values.activity_platform) {
            errors.activity_platform = "Activity Platform is Required";
          }

          // if (!values.activity_location) {
          //   errors.activity_location = "Activity location is Required";
          // }

          if (campaign && !values.campaign) {
            errors.campaign = "Activity Campaign is Required";
          }

          if (!values.activity_status) {
            errors.activity_status = "Activity status is Required";
          }

          // if (!values.activity_content) {
          //   errors.activity_content = "Activity Content is Required";
          // }

          // if (!values.activity_type) {
          //   errors.activity_type = "Activity type is Required";
          // }

          // if (!values.activity_tag.length) {
          //   errors.activity_tag = "Activity Tags are Required";
          // }

          return errors;
        }}
        onSubmit={(values, formikHelpers, actions) => {
          // setTimeout(() => {
          //   actions.setSubmitting(false);
          // }, 500);
          let date_format = [];

          if (values.activity_duration[0]) {
            date_format.push(values.activity_duration[0].$d);
          }

          if (values.activity_duration[1]) {
            date_format.push(values.activity_duration[1].$d);
          }

          // const return_activity_duration = (duration) => {
          //   let duration_object = {};
          //   duration_object.from_date = format(duration[0], "yyyy-MM-dd");
          //   duration_object.to_date = format(duration[1], "yyyy-MM-dd");

          //   return duration_object;
          // };
          setLoading(true);
          let obj = {};
          Object.assign(
            obj,
            values.activity_name && {
              activity_name: values.activity_name,
            },
            values.description && { description: values.description },
            values.activity_duration && {
              activity_duration: {
                from_date: date_format[0]
                  ? format(date_format[0], "yyyy-MM-dd")
                  : values.activity_duration[0],
                to_date: date_format[1]
                  ? format(date_format[1], "yyyy-MM-dd")
                  : values.activity_duration[1],
              },
            },
            // values.thumbnail_url && { thumbnail_url: values.thumbnail_url },
            values.activity_url && { activity_url: values.activity_url },
            props.campaignList && {
              campaign: props.campaignList && props.campaignList[0],
            },
            values.activity_platform && {
              activity_platform: values.activity_platform,
            },
            // values.activity_location && {
            //   activity_location: values.activity_location,
            // },
            values.campaign && {
              campaign: values.campaign,
            },
            {
              influencer: {
                influencer_id: localStorage.getItem("userId"),
                influencer_name: props?.user?._source?.influencer_name,
              },
            },
            values.activity_content && {
              activity_content: values.activity_content,
            },

            values.activity_type && {
              activity_type: {
                activity_type_id: values.activity_type.activity_type_id,
                activity_type_name: values.activity_type.activity_type_name,
              },
            },
            // values.activity_tag && {
            //   activity_tag: values.activity_tag.map((item) => {
            //     return item.tag_id;
            //   }),
            // },

            values.activity_status && {
              activity_status: values.activity_status.status_id,
            }
            // values.custom_value && { custom_fields: values.custom_value }
          );

          // parameter for showing list based on the modified_by
          if (props.edit) {
            props
              .dispatch(
                InfluencersActivityAction.requestPutInfluencersActivity(
                  obj,
                  props.activityEditData._id
                )
              )
              .then(() => {
                let filter = [];
                if (
                  props.location !== null &&
                  props.location.state &&
                  props.location.state.campaign_name
                ) {
                  filter.push(
                    `["campaign.campaign_name.keyword","must","","term","${props.location.state.campaign_name}"]`
                  );
                }
                let param = {};

                Object.assign(
                  param,
                  { page_limit: "15" },
                  { order_by: '[["created_on", "desc"]]' },
                  props.location &&
                    props.location.state &&
                    props.location.state.from === "/InfluencersCampaigns" && {
                      filters: `[${filter}]`,
                    }
                );

                let params = {};

                Object.assign(
                  params,
                  { page_limit: "none" },
                  { order_by: '[["created_on", "desc"]]' },
                  props.location &&
                    props.location.state &&
                    props.location.state.from === "/InfluencersCampaigns" && {
                      filters: `[${filter}]`,
                    }
                );
                props.dispatch(
                  InfluencersActivityAction.requestInfluencersActivity(param)
                );
                props.dispatch(
                  InfluencersActivityAction.requestInfluencersActivityFilter(
                    params
                  )
                );
                props.onClose();
                setLoading(false);
              });
          } else {
            props
              .dispatch(
                InfluencersActivityAction.requestPostInfluencersActivity(obj)
              )
              .then(() => {
                let filter = [];
                if (
                  props.location !== null &&
                  props.location.state &&
                  props.location.state.campaign_name
                ) {
                  filter.push(
                    `["campaign.campaign_name.keyword","must","","term","${props.location.state.campaign_name}"]`
                  );
                }
                let param = {};

                Object.assign(
                  param,
                  { page_limit: "15" },
                  { order_by: '[["created_on", "desc"]]' },
                  props.location &&
                    props.location.state &&
                    props.location.state.from === "/InfluencersCampaigns" && {
                      filters: `[${filter}]`,
                    }
                );

                let params = {};

                Object.assign(
                  params,
                  { page_limit: "none" },
                  { order_by: '[["created_on", "desc"]]' },
                  props.location &&
                    props.location.state &&
                    props.location.state.from === "/InfluencersCampaigns" && {
                      filters: `[${filter}]`,
                    }
                );

                props.dispatch(
                  InfluencersActivityAction.requestInfluencersActivity(param)
                );
                props.dispatch(
                  InfluencersActivityAction.requestInfluencersActivityFilter(
                    params
                  )
                );
                props.onClose();
                setLoading(false);
              });
          }

          formikHelpers.resetForm();
        }}
      >
        {({
          values,
          errors,
          isValid,
          touched,
          dirty,
          handleChange,
          setFieldValue,
          submitForm,
        }) => (
          <Form>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "0px",
              }}
            >
              <DialogContentText sx={{ width: "90%" }}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  pl={"8vw"}
                >
                  <Grid item xs={10}>
                    <h3 className="dailogtext">
                      <b>
                        {!props.edit ? (
                          <>
                            <span className="span_first_letter">A</span>dd{" "}
                          </>
                        ) : (
                          <>
                            <span className="span_first_letter">E</span>dit{" "}
                          </>
                        )}
                        <span className="span_first_letter">A</span>ctivity{" "}
                        <span className="span_first_letter">D</span>etails
                      </b>{" "}
                    </h3>
                  </Grid>
                  <Grid item>
                    <HighlightOffTwoToneIcon
                      id="closeIcon"
                      sx={{
                        cursor: "pointer",
                        "&:hover": {
                          color: theme.palette.secondary.main,
                          transform: "scale(1.1)",
                          transition: "transform 0.2s ease-in-out",
                        },
                      }}
                      onClick={() => {
                        props.onClose();
                      }}
                    />
                    <Popover
                      open={popperOpen}
                      anchorEl={document.getElementById("closeIcon")}
                      onClose={handlePopoverClose}
                      arrow
                      anchorOrigin={{
                        vertical: "center",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "center",
                        horizontal: "left",
                      }}
                      slotProps={{
                        paper: {
                          style: {
                            marginLeft: "10px",
                            border: `1px solid ${theme.palette.primary.main}`,
                            borderRadius: "5px",
                            boxShadow: "12px 12px 6px rgba(0, 0, 0, 0.6)",
                          },
                        },
                      }}
                    >
                      <Typography p={1}>Click here to close Dialog</Typography>
                    </Popover>
                  </Grid>
                </Grid>
              </DialogContentText>

              {/* {!props.edit ? ( */}

              <Grid lg={12} md={12} sm={12} xs={12} sx={{ display: "flex" }}>
                <Grid lg={6} md={6} sm={6} xs={6}>
                  <Grid container mt={1}>
                    <Grid item lg={12} md={12} sm={12} container>
                      <Grid item lg={4} md={3} sm={3} ml={5} mt={1}>
                        Activity Name * :
                      </Grid>
                      <Grid item lg={6} md={6} sm={6}>
                        <Field
                          variant="outlined"
                          size="small"
                          id="activity_name"
                          as={MuiTextField}
                          name="activity_name"
                          placeholder="Activity Name"
                          error={
                            Boolean(errors.activity_name) &&
                            Boolean(touched.activity_name)
                          }
                          helperText={
                            Boolean(touched.activity_name) &&
                            errors.activity_name
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container mt={1}>
                    <Grid item lg={12} md={12} sm={12} container>
                      <Grid item lg={4} md={3} sm={3} ml={5} mt={1}>
                        Activity URL * :
                      </Grid>
                      <Grid item lg={6} md={6} sm={6}>
                        {/* <Field
                          variant="outlined"
                          size="small"
                          id="thumbnail_url"
                          as={MuiTextField}
                          name="thumbnail_url"
                          placeholder="Thumbnail Url"
                          error={
                            Boolean(errors.thumbnail_url) &&
                            Boolean(touched.thumbnail_url)
                          }
                          helperText={
                            Boolean(touched.thumbnail_url) &&
                            errors.thumbnail_url
                          }
                        /> */}
                        <Field
                          variant="outlined"
                          size="small"
                          id="activity_url"
                          as={MuiTextField}
                          name="activity_url"
                          placeholder="Activity Url"
                          error={
                            Boolean(errors.activity_url) &&
                            Boolean(touched.activity_url)
                          }
                          helperText={
                            Boolean(touched.activity_url) && errors.activity_url
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container mt={-1}>
                    <Grid item lg={12} md={12} sm={12} container>
                      <Grid item lg={4} md={3} sm={3} ml={5} mt={3}>
                        Activity Type :
                      </Grid>
                      <Grid item lg={6} md={6} sm={6}>
                        <Field
                          name="activity_type"
                          size="small"
                          component={AutoCompleteMultiSelect}
                          getOptionLabel={(option) =>
                            option.activity_type_name
                              ? option.activity_type_name
                              : ""
                          }
                          isOptionEqualToValue={(value, option) =>
                            value.activity_type_id === option.activity_type_id
                          }
                          options={
                            filtered_activity_type_list.length > 0
                              ? filtered_activity_type_list
                              : []
                          }
                          textFieldProps={{
                            margin: "normal",
                            variant: "outlined",
                            placeholder: "Actiity Type",
                          }}
                          error={Boolean(
                            getIn(touched, "activity_type") &&
                              getIn(errors, "activity_type")
                          )}
                          helperText={
                            getIn(touched, "activity_type") &&
                            getIn(errors, "activity_type")
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* {campaign && ( */}
                  <Grid container mt={-1}>
                    <Grid item lg={12} md={12} sm={12} container>
                      <Grid item lg={4} md={3} sm={3} ml={5} mt={3}>
                        Campaign :
                      </Grid>
                      <Grid item lg={6} md={6} sm={6}>
                        <Field
                          disabled={!campaign}
                          name="campaign"
                          size="small"
                          component={AutoCompleteMultiSelect}
                          getOptionLabel={(option) =>
                            option.campaign_name ? option.campaign_name : ""
                          }
                          options={
                            props.campaignList ? props.campaignList : null
                          }
                          onChange={(_, value) => {
                            setFieldValue(`campaign`, value);
                            setFieldValue(`activity_type`, "");
                            fetchCampaignFunction(value);
                          }}
                          value={values.campaign ? values.campaign : null}
                          textFieldProps={{
                            margin: "normal",
                            variant: "outlined",
                            placeholder: "Campaign",
                          }}
                        />
                        {values.campaign
                          ? setCampaignId(values.campaign.campaign_id)
                          : null}
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* )} */}
                  {!campaign && values.campaign
                    ? setCampaignId(values.campaign.campaign_id)
                    : null}
                </Grid>

                <Grid lg={6} md={6} sm={6} xs={6}>
                  <Grid container mt={1}>
                    <Grid item lg={12} md={12} sm={12} container>
                      <Grid item lg={4} md={3} sm={3} ml={5} mt={1}>
                        Date * :
                      </Grid>
                      <Grid item lg={6} md={6} sm={6}>
                        <Field
                          component={DateRangePickerFormik}
                          size={"small"}
                          value={
                            values.activity_duration
                              ? values.activity_duration
                              : ""
                          }
                          name={"activity_duration"}
                          label={false}
                          textFieldProps={{
                            fullWidth: true,
                            margin: "normal",
                            variant: "outlined",
                            startPlaceHolder: "From date",
                            endPlaceHolder: "End date",
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* <Grid container mt={-1}>
                    <Grid item lg={12} md={12} sm={12} container>
                      <Grid item lg={4} md={3} sm={3} ml={5} mt={3}>
                        Geo Location * :
                      </Grid>
                      <Grid item lg={6} md={6} sm={6}>
                        <Field
                          name="activity_location"
                          size="small"
                          component={AutoCompleteMultiSelect}
                          //   getOptionLabel={(option) =>
                          //     option.organization_name ? option.organization_name : ""
                          //   }
                          options={
                            props.locationsList ? props.locationsList : null
                          }
                          value={
                            values.activity_location
                              ? values.activity_location
                              : null
                          }
                          textFieldProps={{
                            margin: "normal",
                            variant: "outlined",
                            placeholder: "Activity Locations",
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid> */}

                  <Grid container mt={-1}>
                    <Grid item lg={12} md={12} sm={12} container>
                      <Grid item lg={4} md={3} sm={3} ml={5} mt={3}>
                        Platform * :
                      </Grid>
                      <Grid item lg={6} md={6} sm={6}>
                        <Field
                          disabled={!values.campaign}
                          name="activity_platform"
                          size="small"
                          options={
                            activity_platform_list ? activity_platform_list : []
                          }
                          component={AutoCompleteMultiSelect}
                          getOptionLabel={(option) =>
                            option.platform_name ? option.platform_name : ""
                          }
                          isOptionEqualToValue={(value, option) =>
                            value.platform_name === option.platform_name
                          }
                          textFieldProps={{
                            margin: "normal",
                            variant: "outlined",
                            placeholder: "Platform",
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* {props.tagList.length > 0 &&
                  props.tagList.length === 1 ? null : (
                    <Grid container mt={-1}>
                      <Grid item lg={12} md={12} sm={12} container>
                        <Grid item lg={4} md={3} sm={3} ml={5} mt={3}>
                          Activity tags :
                        </Grid>
                        <Grid item lg={6} md={6} sm={6}>
                          <Field
                            name="activity_tag"
                            size="small"
                            component={AutoCompleteMultiSelect}
                            multiple
                            getOptionLabel={(option) =>
                              option.tag_name ? option.tag_name : ""
                            }
                            isOptionEqualToValue={(value, option) =>
                              value.tag_name === option.tag_name
                            }
                            options={
                              props.tagList.length > 0 ? props.tagList : []
                            }
                            // value={values.tag ? values.tag : null}
                            textFieldProps={{
                              margin: "normal",
                              variant: "outlined",
                              placeholder: "Tags",
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  )} */}
                  <Grid container mt={-1}>
                    <Grid item lg={12} md={12} sm={12} container>
                      <Grid item lg={4} md={3} sm={3} ml={5} mt={3}>
                        Activity Status *:
                      </Grid>
                      <Grid item lg={6} md={6} sm={6}>
                        <Field
                          name="activity_status"
                          size="small"
                          options={props.statusList ? props.statusList : []}
                          component={AutoCompleteMultiSelect}
                          getOptionLabel={(option) =>
                            option.status_name ? option.status_name : ""
                          }
                          isOptionEqualToValue={(value, option) =>
                            value.status_id === option.status_id
                          }
                          textFieldProps={{
                            margin: "normal",
                            variant: "outlined",
                            placeholder: "Activity Status",
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* <Grid container mt={-1}>
                <Grid item lg={12} md={12} sm={12} container>
                  <Grid item lg={4} md={3} sm={3} ml={5} mt={3}>
                    Influencer Name :
                  </Grid>
                  <Grid item lg={6} md={6} sm={6}>
                    <Field
                      name="influencer"
                      size="small"
                      component={AutoCompleteMultiSelect}
                      getOptionLabel={(option) =>
                        option.influencer_name ? option.influencer_name : ""
                      }
                      options={
                        props.influencers_list ? props.influencers_list : []
                      }
                      value={values.influencer ? values.influencer : null}
                      textFieldProps={{
                        margin: "normal",
                        variant: "outlined",
                        placeholder: "Influencer Name",
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid> */}
                </Grid>
              </Grid>

              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                className="labelFieldBox"
                container
                spacing={2}
                mt={1}
              >
                <Grid item lg={2} md={3} sm={3} ml={5}>
                  Activity Description * :
                </Grid>
                <Grid item lg={9} md={6} sm={6}>
                  <Field
                    className={
                      touched.description && errors.description
                        ? "ticket_desc_test_area_error"
                        : "ticket_desc_test_area"
                    }
                    name="description"
                    component="textarea"
                    value={values.description}
                    onChange={handleChange}
                    type="text"
                    maxRows={3}
                    minRows={3}
                    aria-label="maximum height"
                    placeholder="Activity Description"
                    label="description"
                  />
                  <Box px={1}>
                    <ErrorMessage name="description" />
                  </Box>
                </Grid>
              </Grid>

              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                className="labelFieldBox"
                container
                spacing={2}
                mt={1}
              >
                <Grid item lg={2} md={3} sm={3} ml={5}>
                  Activity Content :
                </Grid>
                <Grid item lg={9} md={6} sm={6}>
                  <Field
                    className={
                      touched.activity_content && errors.activity_content
                        ? "ticket_desc_test_area_error"
                        : "ticket_desc_test_area"
                    }
                    name="activity_content"
                    component="textarea"
                    value={values.activity_content}
                    onChange={handleChange}
                    type="text"
                    maxRows={5}
                    minRows={3}
                    aria-label="maximum height"
                    placeholder="Activity Content"
                    label="activity_content"
                  />
                  <Box px={1}>
                    <ErrorMessage name="activity_content" />
                  </Box>
                </Grid>
              </Grid>

              {/* <Grid item lg={12} md={12} sm={12} container spacing={2} mt={1}>
                <Grid item lg={2} md={3} sm={3} ml={5}>
                  Attachment :
                </Grid>
                <Grid item lg={9} md={6} sm={6}>
                  {fileInputs.map((item) => (
                    <Grid
                      container
                      key={item.id}
                      justifyContent="space-between"
                      mb={0.5}
                    >
                      <input
                        disabled={values.boolean}
                        type="file"
                        onChange={(e) => {
                          handlFileUpload(e.target.files[0], setFieldValue, e);
                        }}
                      />
                      <Tooltip title="Remove File" arrow placement="right">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            border: `1px solid ${theme.palette.primary.main}`,
                            borderRadius: "5px",
                            cursor: "pointer",
                            padding: "7px",
                            "&:hover": {
                              color: "white",
                              backgroundColor: theme.palette.secondary.main,
                            },
                          }}
                          onClick={() => handleRemoveFile(item.id)}
                        >
                          <Box mr={0.5}>Remove</Box>
                          <RemoveCircleOutlineTwoToneIcon />
                        </Box>
                      </Tooltip>
                    </Grid>
                  ))}
                  <Grid container justifyContent="flex-end">
                    <Tooltip title="Add File" arrow placement="right">
                      <Grid
                        xs={1.85}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          border: `1px solid ${theme.palette.primary.main}`,
                          borderRadius: "5px",
                          cursor: "pointer",
                          padding: "7px",
                          "&:hover": {
                            color: "white",
                            backgroundColor: theme.palette.primary.main,
                          },
                        }}
                        onClick={handleAddFile}
                      >
                        <Box flexGrow={1} textAlign="center" mr={0.5}>
                          Add
                        </Box>
                        <AddCircleOutlineIcon />
                      </Grid>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid> */}

              {/* <Box
                mt={1}
                sx={{
                  width: "100%",
                  boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
                }}
              >
                <Accordion
                  sx={
                    {
                      // backgroundColor:"#f3f9fb"
                    }
                  }
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <h4>Additional Fields</h4>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      width: "100%",
                      height: 220,
                      overflow: "auto",
                      overscrollBehaviorY: "contain",
                    }}
                  >
                    {values.custom_value &&
                      values.custom_value.map((item, index) => {
                        if (item.field_type === "text") {
                          return (
                            <Grid
                              item
                              xl={12}
                              lg={12}
                              laptop={12}
                              md={12}
                              sm={12}
                              mt={1}
                              key={index}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Grid lg={2} md={2} sm={2} mt={1}>
                                <label htmlFor={item.field_name}>
                                  {item.field_name} {" :"}
                                </label>
                              </Grid>
                              <Grid lg={10} md={10} sm={10}>
                                <Field
                                  id={item.field_id}
                                  name={`custom_value.${index}.field_values[0].value`}
                                  render={({ field }) => (
                                    <MuiTextField
                                      name={`custom_value.${index}.field_values[0].value`}
                                      size="small"
                                      value={item.field_values[0].value}
                                      onChange={handleChange}
                                    />
                                  )}
                                  type="text"
                                  varient="outlined"
                                />
                              </Grid>
                            </Grid>
                          );
                        } else if (item.field_type === "select") {
                          return (
                            <Grid
                              item
                              xl={12}
                              lg={12}
                              laptop={12}
                              md={12}
                              sm={12}
                              mt={1}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Grid lg={2} md={2} sm={2} mt={3}>
                                <label htmlFor={item.field_name}>
                                  {item.field_name}
                                  {" :"}
                                </label>
                              </Grid>
                              <Grid lg={10} md={10} sm={10}>
                                <Field
                                  name={`custom_value.${index}.field_values[0]`}
                                  // value={custom_value[index].field_values[0]}
                                  component={AutoCompleteMultiSelect}
                                  options={
                                    props.customticketfields.hits &&
                                    props.customticketfields.hits.hits.filter(
                                      (e) => {
                                        return e._id === item.field_id;
                                      }
                                    ).length != 0
                                      ? props.customticketfields.hits.hits.filter(
                                          (e) => {
                                            return e._id === item.field_id;
                                          }
                                        )[0]._source.field_values
                                      : []
                                  }
                                  size="small"
                                  isOptionEqualToValue={(option, value) =>
                                    //setting value property to custom value
                                    option.value === value.value
                                  }
                                  //setting custom label to custom value
                                  getOptionLabel={(option) =>
                                    option.value ? option.value : ""
                                  }
                                  textFieldProps={{
                                    fullWidth: true,
                                    margin: "normal",
                                    variant: "outlined",
                                  }}
                                  // multiple
                                />
                              </Grid>
                            </Grid>
                          );
                        } else if (item.field_type === "toggle") {
                          return (
                            <Grid
                              item
                              xl={12}
                              lg={12}
                              laptop={12}
                              md={12}
                              sm={12}
                              mt={1}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Grid lg={2} md={2} sm={2} mt={1}>
                                <label htmlFor={item.field_name}>
                                  {item.field_name}
                                </label>
                                {" :"}
                              </Grid>
                              <Grid lg={10} md={10} sm={10}>
                                <FormControlLabel
                                  control={
                                    <Field
                                      component={SwitchButton}
                                      type="checkbox"
                                      name={`custom_value.${index}.field_values[0].value`}
                                      checked={
                                        item.field_values[0]
                                          ? item.field_values[0].value
                                          : null
                                      }
                                    />
                                  }
                                />
                              </Grid>
                            </Grid>
                          );
                        } else if (item.field_type === "multiselect") {
                          return (
                            <Grid
                              item
                              xl={12}
                              mt={2}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Grid lg={2} md={2} sm={2} mt={1}>
                                <label htmlFor={item.field_name}>
                                  {item.field_name}
                                </label>
                                {" :"}
                              </Grid>
                              <Grid lg={10} md={10} sm={10}>
                                <Field
                                  name={item.field_name}
                                  component={AutoCompleteMultiSelect}
                                  multiple
                                  label={item.field_name}
                                  size="small"
                                  options={item.field_values}
                                  isOptionEqualToValue={(option, value) =>
                                    //setting value property to custom value
                                    option.value === value.value
                                  }
                                  //setting custom label to custom value
                                  getOptionLabel={(option) => option.value}
                                  textFieldProps={{
                                    fullWidth: true,
                                    margin: "normal",
                                    variant: "outlined",
                                  }}
                                />
                              </Grid>
                            </Grid>
                          );
                        } else if (item.field_type === "date") {
                          return (
                            <Grid
                              item
                              xl={12}
                              lg={12}
                              md={12}
                              sm={12}
                              mt={2}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Grid lg={2} md={2} sm={2} mt={3}>
                                <label htmlFor={item.field_name}>
                                  {item.field_name}
                                </label>
                                {" :"}
                              </Grid>
                              <Grid lg={10} md={10} sm={10}>
                                <Field
                                  component={DatePickerComponent}
                                  size="small"
                                  name={`custom_value.${index}.field_values[0].value`}
                                  label={false}
                                  textFieldProps={{
                                    fullWidth: true,
                                    margin: "normal",
                                    variant: "outlined",
                                  }}
                                />
                              </Grid>
                            </Grid>
                          );
                        }
                      })}
                  </AccordionDetails>
                </Accordion>
              </Box> */}
            </DialogContent>

            <DialogActions>
              <Grid
                container
                item
                lg={12}
                md={12}
                sm={12}
                display="flex"
                justifyContent="space-evenly"
              >
                <Grid item lg={4.8} md={5} sm={5} mb={3}>
                  {!props.edit ? (
                    <MuiButton
                      name={"Add Activity"}
                      loading={loading || values.boolean}
                      type="submit"
                      width="100%"
                      buttonRef={buttonForLoginRef}
                    />
                  ) : (
                    <MuiButton
                      name={"Submit"}
                      loading={loading}
                      // type="submit"
                      onClick={submitForm}
                      width="100%"
                      buttonRef={buttonForLoginRef}
                    />
                  )}
                </Grid>

                <Grid item lg={4.8} md={5} sm={5} mb={3}>
                  {!props.edit ? (
                    <MuiButton
                      name={"Reset"}
                      type="reset"
                      onClick={Formik.resetForm}
                      width="100%"
                    />
                  ) : (
                    <MuiButton
                      name={"Cancel"}
                      onClick={() => {
                        props.onClose();
                        setactivity_platform_list([]);
                        Formik.resetForm();
                      }}
                      width="100%"
                    />
                  )}
                </Grid>
              </Grid>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export default connect(mapStateToProps)(AddAllActivity);
